export const TOKEN = 'token';
export const REFRESH_TOKEN = 'refresh_token';
export const REDIRECT_AFTER_AUTH = 'redirectToAfterLogin';
export const REDIRECT_AFTER = 'redirectToAfter';
export const USER_STORAGE = 'user_info';
